"use strict";
/* tooltip portal util */
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionTooltipElementAndShow = void 0;
// get corner positions of an element
const getDomElementAbsoluteRect = (el) => {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        top: rect.top + scrollTop,
        height: rect.height,
        bottom: rect.bottom + scrollTop,
        left: rect.left + scrollLeft,
        width: rect.width,
        right: rect.right + scrollLeft
    };
};
// get total window sizes
const getWindowSizes = () => {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        windowWidth: viewportWidth + scrollLeft,
        windowHeight: viewportHeight + scrollTop
    };
};
// tooltip positions enums
var TooltipPlaceEnums;
(function (TooltipPlaceEnums) {
    TooltipPlaceEnums["above"] = "above";
    TooltipPlaceEnums["right"] = "right";
    TooltipPlaceEnums["below"] = "below";
    TooltipPlaceEnums["left"] = "left";
})(TooltipPlaceEnums || (TooltipPlaceEnums = {}));
var TooltipAnchorEnums;
(function (TooltipAnchorEnums) {
    TooltipAnchorEnums["top"] = "top";
    TooltipAnchorEnums["right"] = "right";
    TooltipAnchorEnums["center"] = "center";
    TooltipAnchorEnums["bottom"] = "bottom";
    TooltipAnchorEnums["left"] = "left";
})(TooltipAnchorEnums || (TooltipAnchorEnums = {}));
// A window buffer to leave some space between the extreme positions of the re-positioned tooltip and the window borders
const TOOLTIP_WINDOW_BUFFER = 15;
// position the tooltip element once mounted
// place and shift elements according to position configuration, then show
const positionTooltipElementAndShow = (tooltipEl, clientRefEl, position, arrowEl, delay) => {
    // get window size
    const { windowWidth, windowHeight } = getWindowSizes();
    // get client rect position
    const { top: clientTop, height: clientHeight, bottom: clientBottom, left: clientLeft, width: clientWidth, right: clientRight } = getDomElementAbsoluteRect(clientRefEl);
    // check the size of the tooltip to display
    const { height: tooltipHeight, width: tooltipWidth } = getDomElementAbsoluteRect(tooltipEl);
    // check the height of the upward arrow
    const { height: arrowSize } = getDomElementAbsoluteRect(arrowEl);
    const { style: tooltipStyle } = tooltipEl;
    tooltipStyle.width = `${tooltipWidth}px`;
    tooltipStyle.height = `${tooltipHeight}px`;
    const { style: arrowStyle } = arrowEl;
    let arrowRotation = 0;
    // read positioning specification
    let { place = TooltipPlaceEnums.below } = position;
    const { placeShift = 0, adjustPlace = false, anchor = TooltipAnchorEnums.center, anchorShift = 0, adjustAnchor = true } = position;
    const totalPlaceShift = placeShift + arrowSize;
    // try to apply the position spec and move to the other side if it feels better...
    // a first run through the potential places
    // checking if we should adjust
    // ie if part of the tooltip is hidden in the prefered direction and if the opposite could give more room
    // how much room would remain given place ?
    const roomBelow = windowHeight - clientBottom - totalPlaceShift - tooltipHeight;
    const roomAbove = clientTop - totalPlaceShift - tooltipHeight;
    const roomLeft = clientLeft - totalPlaceShift - tooltipWidth;
    const roomRight = windowWidth - clientRight - totalPlaceShift - tooltipWidth;
    switch (place) {
        case TooltipPlaceEnums.above:
            if (adjustPlace &&
                roomAbove < TOOLTIP_WINDOW_BUFFER &&
                roomBelow > roomAbove) {
                // partly hidden above and there is more space below
                place = TooltipPlaceEnums.below;
            }
            break;
        case TooltipPlaceEnums.left:
            if (adjustPlace &&
                roomLeft < TOOLTIP_WINDOW_BUFFER &&
                roomRight > roomLeft) {
                // partly hidden left and there is more space right
                place = TooltipPlaceEnums.right;
            }
            break;
        case TooltipPlaceEnums.right:
            if (adjustPlace &&
                roomRight < TOOLTIP_WINDOW_BUFFER &&
                roomLeft > roomRight) {
                // partly hidden right and there is more space left
                place = TooltipPlaceEnums.left;
            }
            break;
        case TooltipPlaceEnums.below:
        default:
            if (adjustPlace &&
                roomBelow < TOOLTIP_WINDOW_BUFFER &&
                roomAbove > roomBelow) {
                // partly hidden below and there is more space above
                place = TooltipPlaceEnums.above;
            }
    }
    // now do apply the concrete placing
    switch (place) {
        case TooltipPlaceEnums.above:
            tooltipStyle.top = `${Math.max(clientTop - totalPlaceShift - tooltipHeight, TOOLTIP_WINDOW_BUFFER)}px`; // note: don't overflow on the top of the window or we won't be able to scroll anymore
            arrowStyle.top = `${clientTop - totalPlaceShift}px`;
            arrowRotation = 180;
            break;
        case TooltipPlaceEnums.left:
            tooltipStyle.left = `${Math.max(clientLeft - totalPlaceShift - tooltipWidth, TOOLTIP_WINDOW_BUFFER)}px`; // note: don't overflow on the left of the window or we won't be able to scroll anymore
            arrowStyle.left = `${clientLeft - totalPlaceShift}px`;
            arrowRotation = 90;
            break;
        case TooltipPlaceEnums.right:
            tooltipStyle.left = `${clientRight + totalPlaceShift}px`;
            arrowStyle.left = `${clientRight + placeShift}px`;
            arrowRotation = 270;
            break;
        case TooltipPlaceEnums.below:
        default:
            tooltipStyle.top = `${clientBottom + totalPlaceShift}px`;
            arrowStyle.top = `${clientBottom + placeShift}px`;
    }
    // now it's placed look at the cross axis positioning
    // try to apply the anchor spec first and then potentialy move it a bit
    if (place === TooltipPlaceEnums.left || place === TooltipPlaceEnums.right) {
        // anchor is vertical
        let tooltipTop = null;
        switch (anchor) {
            case TooltipAnchorEnums.top:
                // anchor the tooltip top
                tooltipTop = clientTop + anchorShift;
                break;
            case TooltipAnchorEnums.bottom:
                // anchor the tooltip bottom
                tooltipTop = clientBottom - tooltipHeight - anchorShift;
                break;
            case TooltipAnchorEnums.center:
            default:
                // center the tooltip
                tooltipTop = Math.floor(clientTop + 0.5 * clientHeight - 0.5 * tooltipHeight + anchorShift);
        }
        // don't overflow top
        tooltipTop = Math.max(tooltipTop, TOOLTIP_WINDOW_BUFFER);
        tooltipStyle.top = `${tooltipTop}px`;
        // check if we should adjust bottom
        if (adjustAnchor &&
            tooltipTop + tooltipHeight > windowHeight - TOOLTIP_WINDOW_BUFFER) {
            tooltipTop = Math.max(tooltipTop -
                (tooltipTop + tooltipHeight - windowHeight + TOOLTIP_WINDOW_BUFFER), TOOLTIP_WINDOW_BUFFER);
            tooltipStyle.top = `${tooltipTop}px`;
        }
        // now compute the size of the arrow container
        // which is the vertical intersection of client and tooltip
        const arrowTop = Math.max(clientTop, tooltipTop);
        arrowStyle.top = `${arrowTop}px`;
        arrowStyle.height = `${Math.min(clientBottom, tooltipTop + tooltipHeight) - arrowTop}px`;
        arrowStyle.width = `${arrowSize}px`;
    }
    else {
        // anchor is horizontal
        let tooltipLeft = null;
        switch (anchor) {
            case TooltipAnchorEnums.right:
                // anchor the tooltip right
                tooltipLeft = clientRight - tooltipWidth - anchorShift;
                break;
            case TooltipAnchorEnums.left:
                // anchor the tooltip left
                tooltipLeft = clientLeft + anchorShift;
                break;
            case TooltipAnchorEnums.center:
            default:
                // center the tooltip
                tooltipLeft = Math.floor(clientLeft + 0.5 * clientWidth - 0.5 * tooltipWidth + anchorShift);
        }
        // don't overflow left
        tooltipLeft = Math.max(tooltipLeft, TOOLTIP_WINDOW_BUFFER);
        tooltipStyle.left = `${tooltipLeft}px`;
        // check if we should adjust right
        if (adjustAnchor &&
            tooltipLeft + tooltipWidth > windowWidth - TOOLTIP_WINDOW_BUFFER) {
            tooltipLeft = Math.max(tooltipLeft -
                (tooltipLeft + tooltipWidth - windowWidth + TOOLTIP_WINDOW_BUFFER), TOOLTIP_WINDOW_BUFFER);
            tooltipStyle.left = `${tooltipLeft}px`;
        }
        // now compute the size of the arrow container
        // which is the horizontal intersection of client and tooltip
        const arrowLeft = Math.max(clientLeft, tooltipLeft);
        arrowStyle.left = `${arrowLeft}px`;
        arrowStyle.width = `${Math.min(clientRight, tooltipLeft + tooltipWidth) - arrowLeft}px`;
        arrowStyle.height = `${arrowSize}px`;
    }
    // finally rotate the arrow
    arrowEl.children[0].style.transform = `rotate(${arrowRotation}deg)`;
    // now it's replaced set the visibility on, potentialy after a delay setup in the props
    setTimeout(() => {
        tooltipStyle.visibility = 'visible';
        arrowStyle.visibility = 'visible';
    }, delay);
};
exports.positionTooltipElementAndShow = positionTooltipElementAndShow;
//# sourceMappingURL=position.js.map